import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface UserQuotaIncrease{
    creators: number;
    explorers: number;
    viewers: number;
}
export interface ServerSiteIdentifier{
    podName: string;
    serverSiteLuid: string;
}

export interface RequestingUser{
    serverSiteUserId: string;
}

export class ExpandUserQuotaRequest
    extends Request<{}, IResult> {

    constructor(userOrderIncrease: UserQuotaIncrease) {
        super('expandUserQuota', {userOrderIncrease});
    }
}
